export const RESET_DOCS_VIEWS = "reset docs views"

export const RESET_ANONYMOUS_ID = "reset anonymous id"

export const SAVE_UTM = "save utm"

export const TOGGLE_GIF_COLLAPSE = "toggle docs gifs collapse"
